import styled, { css } from 'styled-components';
import { Text } from 'components';

export const ToolTipTvSeriesStyled = styled.div`
  position: absolute;
  bottom: 52px;
  left: 50%;
  transform: translateX(-50%);
  background-color: #1a1a1a;
  padding: 7px;
  display: flex;
  flex-direction: row;
  max-height: 70px;
  width: 250px;
  opacity: 0;
  visibility: hidden;
  font-size: 0;

  ${(props) =>
    props.open &&
    css`
      opacity: 1;
      visibility: visible;
    `};

  &:after {
    content: '';
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: -18px;
    border: 10px solid transparent;
    border-top: 10px solid #1a1a1a;
  }
`;

export const LeftPart = styled.div`
  position: relative;
  font-size: 0;
  margin-right: 10px;
`;

export const TextTvWrap = styled.div`
  position: relative;
  margin-bottom: 4px;
`;

export const StyledTvText = styled(Text)`
  white-space: nowrap;
`;

export const TitleTextWrap = styled.div`
  color: white;
`;

export const StyledImage = styled.img`
  position: relative;
  width: 68px;
  height: 44px;
`;

export const StyledText = styled(Text)`
  display: block;
  height: 24px;
`;
